import React from 'react';

/**
 * ErrorBoundary Component
 *
 * Catches JavaScript errors anywhere in the child component tree and displays
 * a fallback UI instead of crashing the whole application.
 *
 * @component
 * @example
 * return (
 *   <ErrorBoundary>
 *     <App />
 *   </ErrorBoundary>
 * )
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log error only in development
    if (process.env.NODE_ENV === 'development') {
      console.error('Error caught by boundary:', error, errorInfo);
    }
    // In production, you could send to error tracking service here
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '2rem',
          backgroundColor: '#f5f1e8',
          fontFamily: "'Inter', sans-serif"
        }}>
          <h1 style={{
            color: '#2a5932',
            fontSize: '2rem',
            marginBottom: '1rem'
          }}>
            Oops! Something went wrong
          </h1>
          <p style={{
            color: '#666',
            fontSize: '1.1rem',
            marginBottom: '2rem',
            textAlign: 'center',
            maxWidth: '600px'
          }}>
            We're sorry for the inconvenience. Please try refreshing the page.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '1rem 2rem',
              backgroundColor: '#2a5932',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'background-color 0.3s ease'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#1a3920'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#2a5932'}
          >
            Refresh Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
